import * as React from "react";

function Logo({ fill = "#fff", height = 24, ...other }) {
  return (
    <svg viewBox="0 0 1360 850" height={height} {...other}>
      <path d="M0 425V0h1360v850H0V425z" fill="#832726" />
      <path
        d="M0 425V0h1360v850H0V425zm770 302c0-2-21-53-46-113s-48-118-52-129c-4-15-9-8-23 30-9 28-30 87-47 133l-31 82h100c54 0 99-1 99-3z"
        fill="#be0a0b"
      />
      <path
        d="M0 425V0h1360v850H0V425zm770 302c0-2-21-53-46-113s-48-118-52-129c-4-15-9-8-23 30-9 28-30 87-47 133l-31 82h100c54 0 99-1 99-3zm157-394c-4-3-10-3-14 0-3 4 0 7 7 7s10-3 7-7zm27-96c16-45 32-86 36-92 4-5 11-25 15-43l7-32h-96c-53 0-96 3-96 8-1 13 94 242 99 242 3 0 19-37 35-83z"
        fill="#c93334"
      />
      <path
        d="M0 425V0h1360v850H0V425zm847 105c64-176 72-193 82-170 6 14 42 102 80 195l69 170 101 3 102 3-14-33c-7-18-67-167-133-331L1015 70H813l-98 268c-53 147-108 295-121 330l-23 63 102-3 102-3 72-195z"
        fill="#6a6967"
      />
      <path
        d="M0 425V0h1360v850H0V425zm847 105c64-176 72-193 82-170 6 14 42 102 80 195l69 170 101 3 102 3-14-33c-7-18-67-167-133-331L1015 70H813l-98 268c-53 147-108 295-121 330l-23 63 102-3 102-3 72-195zM449 215c17-55 36-107 41-116s6-20 3-23c-11-11-193-7-193 5 0 5 12 36 26 67s37 85 51 120 29 60 33 55c4-4 22-53 39-108z"
        fill="#a19fa0"
      />
      <path
        d="M0 425V0h1360v850H0V425zm346 110l61-190 22 50c13 28 50 114 83 193l60 142h203l70-195c39-106 73-191 77-187s23 48 42 97c19 50 53 133 75 185l39 95 101 3 102 3-14-33c-7-18-67-167-132-330L1017 70H813l-58 158c-32 86-64 175-72 197s-16 41-17 43c-2 1-40-88-86-198L496 70H295L191 387C135 561 86 710 83 717c-4 11 14 13 98 11l103-3 62-190z"
        fill={fill}
      />
    </svg>
  );
}

export default Logo;
